import { render, staticRenderFns } from "./DettaglioEvento.vue?vue&type=template&id=baa8a120&scoped=true"
import script from "./DettaglioEvento.vue?vue&type=script&lang=js"
export * from "./DettaglioEvento.vue?vue&type=script&lang=js"
import style0 from "./DettaglioEvento.vue?vue&type=style&index=0&id=baa8a120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa8a120",
  null
  
)

export default component.exports